import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function buildPageTitle({ partnerTitle, pageTitle } = {}) {
  const p = partnerTitle ? String(partnerTitle).trim() : '';
  const t = pageTitle ? String(pageTitle).trim() : '';

  if (p && t) return `${t} | ${p}`;
  return t || p || '';
}

export function setPageTitle({ partnerTitle, pageTitle } = {}) {
  const next = buildPageTitle({ partnerTitle, pageTitle });
  if (next) document.title = next;
  return next;
}

/**
 * React hook for setting the browser tab title.
 *
 * - `pageTitle` can be a fully translated string (recommended).
 * - If you pass `{ i18nKey }`, it will translate via the shared i18n instance.
 * - `partnerTitle` is usually a proper noun/brand and is not translated.
 */
export function usePageTitle(
  { partnerTitle, pageTitle, i18nKey, i18nParams } = {},
  deps = []
) {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const translated = i18nKey ? i18nInstance.t(i18nKey, i18nParams) : pageTitle;
    setPageTitle({ partnerTitle, pageTitle: translated });
  }, [partnerTitle, pageTitle, i18nKey, i18nParams, i18nInstance.language, ...deps]);
}
